import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { RelationProjectState, relationProjectStateAsString } from "../RelationProjectState";

export const DefaultOverviewFilter: CompositeFilterDescriptor = {
  filters: [
    {
      logic: "or",
      filters: [
        {
          field: "ProjectState",
          operator: "eq",
          value: relationProjectStateAsString.get(RelationProjectState.Launched),
        },
        {
          field: "ProjectState",
          operator: "eq",
          value: relationProjectStateAsString.get(RelationProjectState.InterimLaunched),
        },
      ],
    },
  ],
  logic: "and",
};
